<template>
  <div id="Breadcrumb">
    <a-breadcrumb separator=">">
      <a-breadcrumb-item><a href="/">脑医汇首页</a></a-breadcrumb-item>
      <a-breadcrumb-item><a href="/">云课堂</a></a-breadcrumb-item>
      <a-breadcrumb-item><a href="/">收费课程</a></a-breadcrumb-item>
      <a-breadcrumb-item>脑血管病手术集锦</a-breadcrumb-item>
    </a-breadcrumb>
  </div>
</template>

<script>
  import {Breadcrumb} from 'ant-design-vue';

  export default {
    name: "Breadcrumb",
    components: {
      [Breadcrumb.name]: Breadcrumb,
      [Breadcrumb.Item.name]: Breadcrumb.Item,
    },
  }
</script>

<style scoped lang="scss">
  #Breadcrumb{
    @extend %safetyWidth;
  }
  .ant-breadcrumb {
    margin: 0 0 14px;

    span, a {
      color: $theme_blue;
      font-size: 14px;
    }
  }
</style>
